import { Color } from '@diritto/common/style/color';
import { Typography } from '@diritto/common/style/typography';
import styled from '@emotion/styled';
import { Keyword } from 'ui-components/contents/Keyword';

interface ContentItemMetaKeywordsProps {
  className?: string;
  keywords: string[];
  keywordColor?: string;
  maxShowCount?: number;
}

const MAX_KEYWORD_SHOW_COUNT = 3;

export const ContentItemMetaKeywords = ({
  className,
  keywords,
  maxShowCount = MAX_KEYWORD_SHOW_COUNT,
  keywordColor,
}: ContentItemMetaKeywordsProps) => {
  if (keywords.length <= 0) {
    return null;
  }

  return (
    <div className={className}>
      <StyledKeywords>
        {keywords.slice(0, maxShowCount).map(it => (
          <Keyword key={it} keyword={it} color={keywordColor} />
        ))}
        {keywords.length > maxShowCount && <p>{`외 ${keywords.length - maxShowCount}개`}</p>}
      </StyledKeywords>
    </div>
  );
};

const StyledKeywords = styled.div`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  margin-right: -4px;

  > * {
    margin-right: 4px;
  }

  & > p {
    display: inline-block;
    color: ${Color.Gray500};
    ${Typography.XXXSmall};
  }
`;
